import * as tokens from '../theme/videa-style-tokens';

export const colors: any = {
  // RBL
  RED: tokens.red400,
  GREEN: tokens.green400,
  YELLOW: tokens.yellow500,
  ORANGE: tokens.orange700,
  WHITE: tokens.legacyWhite,
  purple: tokens.legacyPurple,
  rootTipHover: tokens.legacyRoottiphover,
  cej: tokens.legacyCej,
  abd: tokens.legacyAbd,
  cariesHighConfidence: tokens.legacyCarieshighconfidence, // slightly lighter red for more certain caries
  cariesConfidenceValueVeryHigh: tokens.cariesConfidenceValueVeryHigh,
  cariesConfidenceValueHigh: tokens.cariesConfidenceValueHigh,
  cariesConfidenceValueMed: tokens.cariesConfidenceValueMed,
  cariesConfidenceValueLow: tokens.cariesConfidenceValueLow,
  cariesConfidenceValueVeryLow: tokens.cariesConfidenceValueVeryLow,
  cariesMediumConfidence: tokens.legacyCariesmediumconfidence,
  cariesLowConfidence: tokens.legacyCarieslowconfidence, // slightly lighter orange for less certain cavities
  opaqueYellowOrange: tokens.yellowOrange30085,
  Agree: tokens.legacyAgree, // anything agreed is red
  Monitor: tokens.legacyMonitor, // anything monitored is orange
  hover: tokens.legacyHover, // light blue
  PURE_WHITE: tokens.legacyPureWhite,
  OFF_WHITE: tokens.legacyOffWhite,
  DIM_WHITE: tokens.legacyDimWhite,
  LIGHT_WHITE: tokens.legacyLightWhite,
  LIGHT_WHITE_2: tokens.legacyLightWhite2,
  PURE_BLACK: tokens.legacyPureBlack,
  MID_BLACK: tokens.legacyMidBlack,
  DARKER_GREY: tokens.legacyDarkerGrey,
  VERY_DARK_GREY: tokens.legacyVeryDarkGrey,
  DARK_GREY: tokens.legacyDarkGrey,
  MID_GREY: tokens.legacyMidGrey,
  MID_GREY_2: tokens.legacyMidGrey2,
  MID_LIGHTER_GREY: tokens.legacyMidLighterGrey,
  MID_LIGHT_GREY: tokens.legacyMidLightGrey,
  VERY_LIGHT_GREY: tokens.legacyVeryLightGrey,
  PRIMARY: tokens.legacyPrimary,
  PRIMARY_HIGHLIGHT: tokens.legacyPrimaryHighlight,
  SECONDARY: tokens.legacySecondary,
  PURPLE: tokens.legacyPurple,
  LIGHT_PURPLE: tokens.legacyLightPurple,
  LIGHT_GREY: tokens.legacyLightGrey,
  QUOTE: tokens.legacyQuote,
  CAPTION: tokens.legacyCaption,
  HEADER: tokens.white,
  DARK_BLUE: tokens.legacyDarkBlue,
  MID_BLUE: tokens.legacyMidBlue,
  BLUE: tokens.legacyBlue,
  LIGHT_SKY_BLUE: tokens.legacyLightSkyBlue,
  DARK_YELLOW: tokens.legacyDarkYellow,
  MID_GREEN: tokens.legacyMidGreen,
  VIOLET: tokens.legacyViolet,
  GREY_BORDER: tokens.legacyGreyBorder,
  INSIPIENT_MARKS: tokens.legacyInsipientMarks,
  BLUE_ICON: tokens.legacyBlueIcon,
  HEADER_BG_COLOR: tokens.blueBlack640,
} as const;

export const constants = {
  IS_MAC: window.navigator.platform.toLocaleLowerCase().includes('mac'),
};

export const layout = {
  APP_HEADER_HEIGHT: 80,
  APP_BREADCRUMBS_HEIGHT: 40,
  TOOLBAR_HEIGHT: 42,
  // TODO: Add window control height as soon as custom window controls are properly defined
  APP_WINDOW_CONTROLS_HEIGHT: constants.IS_MAC ? 24 : 0,
  COLLAPSED_SIDEBAR_WIDTH: 35,
  FINDINGS_SIDEBAR_WIDTH: 360,
  ABOUT_SIDEBAR_WIDTH: 244,
};
